export default {
	isVisible(elm, threshold, mode) {
		threshold = threshold || 0
		mode = mode || "visible"

		let rect = elm.getBoundingClientRect()
		let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
		let above = rect.bottom - threshold < 0
		let below = rect.top - viewHeight + threshold >= 0

		return mode === "above" ? above : (mode === "below" ? below : !above && !below)
	},
	createPromise() {
		let resolve = null
		let reject = null
		const promise = new Promise((res, rej) => {
			resolve = res
			reject = rej
		})
		return {
			promise: promise,
			resolve: resolve,
			reject: reject
		}
	}
}